import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent
    from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from "@/router";
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
    const refListTable = ref(null)
    const toast = useToast()

    const tableColumns = [
        {
            label: 'dmp.actions',
            key: 'actions',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.is_active',
            key: 'is_active',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.name',
            key: 'name',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.description',
            key: 'description',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.type_alarm',
            key: 'alarm_type_name',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.alarm_level',
            key: 'alarm_level_name',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.day_scope',
            key: 'day_scope',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.evaluation_mode',
            key: 'evaluation_mode',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.start_time',
            key: 'start_time',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.end_time',
            key: 'end_time',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.created_at',
            key: 'created_at',
            sortable: false
        },
        {
            label: 'composite_alarm_rule.updated_at',
            key: 'updated_at',
            sortable: false
        },
    ];

    const perPage = ref(10)
    const totalList = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('event_created_at')
    const isSortDirDesc = ref(true)
    const idPanel = router.currentRoute.params.id_panel;
    const eventCode = ref([])
    const typeAlarm = ref([])

    const idDmpProfile = ref(parseInt(router.currentRoute.params.id_dmp_profile))
    const dataMeta = computed(() => {
        const localItemsCount = refListTable.value ? refListTable.value.$refs.refTable.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalList.value,
        }
    })

    const fetchList = (ctx, callback) => {
        store.dispatch('composite_alarm_rules/getAll', {
            q: searchQuery.value,
            max: perPage.value,
            'page[n]': currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
            .then(response => {
                callback(response.data)
                totalList.value = response.meta?.total ?? response.total ?? 0
            })
            .catch((err) => {
                console.error('fetchList error:', err)
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error obteniendo la información',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const refetchData = () => {
        refListTable.value?.$refs.refTable?.refresh()
    }

    watch([currentPage, perPage], () => {
        refetchData()
    })

    watch([searchQuery], debounce(() => {
        refetchData()
    }, 500))

    const filters = ref({})
    const filtersCount = useFilterCounter(filters)

    const buildFilters = () => {
        filters.value = {
        }

        refetchData()
    }

    const clearSearchFilters = () => {
        buildFilters()
    }

    return {
        tableColumns,
        perPage,
        currentPage,
        totalList,
        fetchList,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refListTable,

        idPanel,
        eventCode,
        typeAlarm,

        refetchData,
        clearSearchFilters,
        buildFilters,
        filtersCount,
        idDmpProfile
    }
}
